import React, { Suspense, useEffect } from "react";
import { Routes, Route, Navigate, Outlet } from "react-router";

// Hooks
import { useAuth } from "hooks";

import RouteWrapper from "./components/RouteWrapper";
// Layouts
import PlanInfo from "WebsitePlan/PlanInfo";
import Payment from "WebsitePlan/Payment";
import PaymentHistory from "WebsitePlan/PaymentHistory";
import OtherChargeList from "WebsitePlan/OtherChargeList";
import OtherPaymentHistory from "WebsitePlan/OtherPaymentHistory";
import PaidServicesManagement from "WebsitePlan/PaidServicesManagement";
import PurchaseServices from "WebsitePlan/PurchaseServices";
import ExtraServicesManagement from "WebsitePlan/ExtraServicesManagement";
import OttSubscription from "WebsitePlan/OttSubscription";
import RegBank from "WebsitePlan/RegBank";
import UnauthorisedUser from "./Layout/UnauthorisedUser";
import AuthorisedUser from "./Layout/AuthorisedUser";

// CSS imports
// import "App.css";
// import "bootstrap/dist/css/bootstrap.min.css";

// Constants
import { ROUTE_CONFIG } from "constants/routes.js";
import { APP_CONFIG } from "constants/app.js";

// Lazy loaded pages for better performance
import PageLoadingFallback from "Pages/PageLoadingFallback";
import UnauthorizedAccess from "Pages/Unauthorized";
import SignIn from "Pages/SignIn";
import Register from "Pages/Register";

import NotFound from "Pages/NotFound";
import MainWalletReports from "Settings/Reports/MainWalletReports";
import WalletReports from "Settings/Reports/WalletReports";
import RechargeReportsPage from "Settings/Reports/RechargeReports";

import MemberManagementPage from "Settings/MemberManagement/MemberManagement";
import MemberSettingManagement from "Settings/MemberManagement/MemberSettingManagement";
import MemberSettingManagements from "Settings/MemberManagement/MemberSettingManagements";
import ChargeSlabManagerPage from "Settings/ResourceManager/ChargeSlabManager";
import ProviderManagerPage from "Settings/ResourceManager/ProviderManager";
import Button from "components/Buttons";
import MoneyTransfer from "Pages/MoneyTransfer";
import SchemeManagementPage from "Settings/ResourceManager/SchemeManagement";
import CommissionTypeManagementPage from "Settings/ResourceManager/CommissionTypeManagement";
import CommissionManagementPage from "Settings/ResourceManager/CommissionManager";
import APIManagementPage from "Settings/ResourceManager/APIManager";
import RoleManagementPage from "Settings/AccountManagement/RoleManagement";
import CompanyManagementPage from "Settings/AccountManagement/CompanyManagement";
import AEPSServicePage from "UserService/AEPS/AEPSServicePage";
import MainAEPSPage from "UserService/AEPS/MainAEPSPage";
import ReceiptPage from "Settings/Reports/ReceiptPage";
import MobileRecharge from "UserService/Recharge&Billpayment/MobileRecharge";
import DTHRecharge from "UserService/Recharge&Billpayment/DTHRecharge";
import RetailerDashboard from "Layout/Dashboard/RetailerDashboard";
import PPIDMTScreen from "UserService/DMT/PPIDMTScreen";
import AdminDashboard from "Layout/Dashboard/AdminDashboard";
import ApiPartnerDashboard from "Layout/Dashboard/APIPartnerDashboard";
import ComingSoon from "Pages/ExtraPages/ComingSoon";
import MainFAQ from "Pages/ExtraPages/MainFAQ";
import PSWalletSettlement from "UserService/Payout/PSWalletSettlement";
import LoadWalletAmount from "Settings/ResourceManager/LoadWalletAmount";
import Error500 from "Pages/ExtraPages/Error500";
import Error503 from "Pages/ExtraPages/Error503";
import Error400 from "Pages/ExtraPages/Error400";
import Error403 from "Pages/ExtraPages/Error403";
import Error404 from "Pages/ExtraPages/Error404";
import ForGotPassword from "Pages/ForgotPassword/Index";
import MainRWalletSettlement from "UserService/Payout/RWalletSettlement";
import { requestNotificationPermission, onMessageListener } from "hooks/firebase";
import UserCommissionManager from "Settings/ViewCommission/UserCommissionManager";
import UserOtherCommissionManager from "Settings/ViewCommission/UsertherCommissionManager";
import PancardServices from "UserService/Pancard/PancardServices";
import BillPayment from "UserService/Recharge&Billpayment/BillPayment";
import AadharpayServicePage from "UserService/AEPS/AadharPayServicePage";
import AepsReportsPage from "Settings/Reports/AEPSReports";
import AEPSCallback from "UserService/AEPS/AEPSCallback";
import PanReports from "UserService/Pancard/MannualPanCardService";
import PanApply from "UserService/Pancard/MannualPanApply";
import DMTCallback from "UserService/DMT/DMTCallback";
import MoneyTransferReportsPage from "Settings/Reports/MoneyTransferReports";
import UserWiseServiceReportPage from "Settings/Reports/UserWiseServiceReportPage";
// <Route path="/reports/user-wise-service" element={<UserWiseServiceReportPage />} />
import DistributorDashboard from "Layout/Dashboard/DistributorDashboard";
import WhiteLabelDashboard from "Layout/Dashboard/WhiteLabelDashboard";
import WalletSettlementReportsPage from "Settings/Reports/WalletSettlementReports";
import PanCardReportsPage from "Settings/Reports/PanCardReports";
import PancardUserDashboard from "Layout/Dashboard/PanCardUserDashboard";
import SoftminTAIrtelDMT from "Pages/MoneyTransfer/SoftMMintDMTAirtel";
import SuperDistributorDashboard from "Layout/Dashboard/SuperDistributorDashboard";
import SoftmintAEPSServicePage from "UserService/AEPS/SoftmintAEPSService";
import BBPSReportsPage from "Settings/Reports/BBPSReports";
import IntraWalletReportsPage from "Settings/Reports/IntraWalletReport";
import BCWalletReportPage from "Settings/Reports/BCWalletReports";
import CreditDebitReportsPage from "Settings/Reports/CreditDebitReports";
import OtherUserMainWalletReportsPage from "Settings/Reports/OtherUserMainWalletReports";
import UserBasedOperatorPage from "Settings/ResourceManager/UserBasedOperatorPage";
import MainOperatorRestrictionPage from "Settings/ResourceManager/MainOperatorRestrictionPage";
import PlanManagerPage from "Settings/ResourceManager/PlanManager/PlanManagerPage";
import PlanServiceChargePage from "Settings/ResourceManager/PlanServiceCharge/PlanServiceChargePage";
import RetailerPlanPage from "Settings/ResourceManager/RetailerPlan/RetailerPlanPage";
import MainServicePage from "Settings/ResourceManager/MainServiceList/MainServicePage";
import LoadWalletPage from "Settings/ResourceManager/LoadWalletPage";
import HomeWebiste from "Pages/Home";
import KYCVerification from "UserService/Verification/KYCVerification";
import RechargeAPIDocs from "UserService/DeveloperAPI/RechargeAPI";
import VerificationAPI from "UserService/DeveloperAPI/VerificationAPI";
import KYCApiDocs from "UserService/DeveloperAPI/KYCApiDocs";
import BannerManagementPage from "Settings/ResourceManager/BannerManagementPage";
import SmsPasswordPage from "Settings/ResourceManager/NewsSection";
import TicketManagementPage from "Settings/ResourceManager/TicketManagement/TicketmanagementPage";
import MemberDetailPage from "Settings/MemberManagement/MemberDetailPage";
import APIIntegrationPage from "Settings/ResourceManager/APIIntegraionRequest";
import AutoLogoutProvider from "contexts/AutoLogoutProvider";
import { RefreshProvider, useRefresh } from "contexts/RefreshContext";
import DeveloperDashboard from "components/DeveloperDashboard";
import OfflineBillPayment from "UserService/Recharge&Billpayment/offlineBBPSPage";
import OfflineBBPSReportsPage from "Settings/Reports/OfflineBBPSReportPage";
import DeletedMembersPage from "Settings/MemberManagement/DeletedMemberManagement";
import SecurityBlockManagementPage from "Settings/MemberManagement/UserSecurityBlock";
import UpiQrReportsPage from "Settings/Reports/UPIQRReports";
import PlatformUserManagementPage from "Settings/PlatFormUserManagement/PlatfromUserManagementPage";
import PlatformUserDashboard from "Layout/Dashboard/PlatformUserDashboard";
import DayWiseUserReportPage from "Settings/Reports/DayWiseReportsConfig";
import FundSummaryReportPage from "Settings/Reports/FundSummaryReports";
import ReportsDashboard from "Pages/ReportsDashboard";
import ExtraServiceManagementPage from "Settings/ResourceManager/ExtraServiceManagementPage";
import SoftmintBBPS from "UserService/Recharge&Billpayment/SoftmintBBPS";
import AgreementScreen from "Settings/ResourceManager/AgreementScreen";
import AgreementListPage from "Settings/ResourceManager/AgreementList";
import AdminMonthlyReport from "Settings/Adminmonthlyreport";
import BillPaymentNEw from "UserService/Recharge&Billpayment/NewBillPayment";
import Cashout from "UserService/Payout/Cashout";
import Cashout2 from "UserService/Payout/Cashout2";
// import LoadWalletPayThroughUpi from "Settings/ResourceManager/AddFundThroughUPI";
import InstantAEPSPAGE from "UserService/AEPS/InstantpayAEPS";
import SmsChargesPage from "Settings/ResourceManager/smsChargePage";
import { apiPanelRouteElements } from "ApiPanel/routes/apiPanelRoutes";
import LoadWalletPayThroughUpi from "Settings/ResourceManager/AddFundThroughUPI";
import LoadWalletPayThroughUpi1 from "Settings/ResourceManager/components/LoadWalletPayThroughUpi";

// inside App component


// App.js



// ── Inner component — lives INSIDE RefreshProvider ──
const AppContent = () => {
  const { isAuthenticated } = useAuth();
  const { refresh } = useRefresh(); // ✅ safe here

  useEffect(() => {
    window.addEventListener('focus', refresh);
    return () => window.removeEventListener('focus', refresh);
  }, [refresh]);

  useEffect(() => {
    requestNotificationPermission().then(token => {
      if (token) console.log("Token stored:", token);
    });

    onMessageListener().then(payload => {
      console.log("Notification received:", payload);
      alert(payload.notification.title + ": " + payload.notification.body);
    });

    const activeTheme = APP_CONFIG.DEFAULT_THEME || "light";
    localStorage.setItem("theme", activeTheme);
    document.documentElement.setAttribute("data-bs-theme", activeTheme);
    document.title = APP_CONFIG.APP_NAME;

    if (APP_CONFIG.IS_DEVELOPMENT) {
      console.log(`🚀 ${APP_CONFIG.APP_NAME} v${APP_CONFIG.APP_VERSION} initialized`);
    }

    window.addEventListener("unhandledrejection", (event) => {
      console.error("🔥 Unhandled Promise Rejection:", event.reason);
      if (window.Sentry) window.Sentry.captureException(event.reason);
    });

    return () => {
      window.removeEventListener("unhandledrejection", () => {});
    };
  }, []);

  return (
    <>
      <Suspense fallback={<PageLoadingFallback message="Initializing application..." />}>
        <Routes>

          {/* ===== PUBLIC ROUTES ===== */}
          <Route path="/" element={<UnauthorisedUser />}>
            <Route path="home" element={<HomeWebiste />} />
            <Route path="login" element={<SignIn />} />
            <Route path="register" element={<Register />} />
            <Route path="forgot_password" element={<ForGotPassword />} />
            
          </Route>

          <Route path="wallet_dmt_success" element={<DMTCallback />} />

          {/* ===== PROTECTED ROUTES ===== */}
          <Route path="/" element={<AutoLogoutProvider><AuthorisedUser /></AutoLogoutProvider>}>
            <Route path="main_wallet_reports" element={<WalletReports />} />
            <Route path="user_main_wallet_reports" element={<OtherUserMainWalletReportsPage />} />
            <Route path="wallet_reports" element={<MainWalletReports />} />
            <Route path="recharge_reports" element={<RechargeReportsPage />} />
            <Route path="upi_qr_reports" element={<UpiQrReportsPage />} />
            <Route path="load_wallet" element={<LoadWalletPage />} />
            
            <Route
              path="load_wallet_upi"
              element={<LoadWalletPayThroughUpi1 show={true} onClose={() => window.history.back()} />}
            />
            <Route path="aeps_reports" element={<AepsReportsPage />} />
            <Route path="pancard_reports" element={<PanCardReportsPage />} />
            <Route path="dmt_reports" element={<MoneyTransferReportsPage />} />
            <Route path="intrawallet_reports" element={<IntraWalletReportsPage />} />
            <Route path="bc_wallet_report" element={<BCWalletReportPage />} />
            <Route path="credit_debit_report" element={<CreditDebitReportsPage />} />
            <Route path="wallet_settlement_reports" element={<WalletSettlementReportsPage />} />
            <Route path="bbps_report" element={<BBPSReportsPage />} />
            <Route path="offline_bbps_report" element={<OfflineBBPSReportsPage />} />
            <Route path="member_management" element={<MemberManagementPage />} />
            <Route path="deleted_member_management" element={<DeletedMembersPage />} />
            <Route path="security_block_management" element={<SecurityBlockManagementPage />} />
            <Route path="/member_details/:id" element={<MemberDetailPage />} />
            <Route path="pancard_management" element={<PancardServices />} />
            <Route path="create_api_integration_request" element={<APIIntegrationPage />} />
            <Route path="pancard_service" element={<PanReports />} />
            <Route path="ticket_management" element={<TicketManagementPage />} />
            <Route path="pancard_apply" element={<PanApply />} />
            <Route path="member_setting_management" element={<MemberSettingManagement />} />
            <Route path="complete_your_registration" element={<MemberSettingManagements />} />
            <Route path="agreement" element={<AgreementScreen />} />
            <Route path="sms_charge" element={<SmsChargesPage />} />
            <Route path="charge_slab_management" element={<ChargeSlabManagerPage />} />
            <Route path="user_commission" element={<UserCommissionManager />} />
            <Route path="user_other_commission" element={<UserOtherCommissionManager />} />
            <Route path="provider_management" element={<ProviderManagerPage />} />
            <Route path="api_docs" element={<RechargeAPIDocs />} />
            <Route path="verification_api_docs" element={<VerificationAPI />} />
            <Route path="kyc_api_docs" element={<KYCApiDocs />} />
            <Route path="user_based_provider_restriction" element={<UserBasedOperatorPage />} />
            <Route path="admin_monthly_report" element={<AdminMonthlyReport />} />
            <Route path="kyc_verification_suite" element={<KYCVerification />} />
            <Route path="day_wise_report" element={<DayWiseUserReportPage />} />
            <Route path="reports" element={<ReportsDashboard />} />
            <Route path="fund_summary_report" element={<FundSummaryReportPage />} />
            <Route path="user_wise_report" element={<UserWiseServiceReportPage />} />
            <Route path="main_provider_restriction" element={<MainOperatorRestrictionPage />} />
            <Route path="plan_manager" element={<PlanManagerPage />} />
            <Route path="plan_service_charge" element={<PlanServiceChargePage />} />
            <Route path="platform_user_management" element={<PlatformUserManagementPage />} />
            <Route path="/platform_user_dashboard" element={<PlatformUserDashboard />} />
            <Route path="retailer_plan_page" element={<RetailerPlanPage />} />
            <Route path="main_service_list" element={<MainServicePage />} />
            <Route path="money_transfer" element={<MoneyTransfer />} />
            <Route path="money_transfer_2" element={<SoftminTAIrtelDMT />} />
            <Route path="scheme_management" element={<SchemeManagementPage />} />
            <Route path="banner_management" element={<BannerManagementPage />} />
            <Route path="extra_service_management" element={<ExtraServiceManagementPage />} />
            <Route path="new_bbps" element={<SoftmintBBPS />} />
            <Route path="news_section" element={<SmsPasswordPage />} />
            <Route path="load_wallet_amount" element={<LoadWalletAmount />} />
            <Route path="instant_aeps_new" element={<InstantAEPSPAGE />} />
            <Route path="add_fund_upi"  element={<LoadWalletPayThroughUpi show={true} onClose={() => {}} />} />
            <Route path="commission_type_management" element={<CommissionTypeManagementPage />} />
            <Route path="commission_management" element={<CommissionManagementPage />} />
            <Route path="api_management" element={<APIManagementPage />} />
            <Route path="role_management" element={<RoleManagementPage />} />
            <Route path="company_management" element={<CompanyManagementPage />} />
            <Route path="aeps_service" element={<AEPSServicePage />} />
            <Route path="aeps_service_2" element={<SoftmintAEPSServicePage />} />
            <Route path="aadharpay_service" element={<AadharpayServicePage />} />
            <Route path="aeps" element={<MainAEPSPage />} />
             <Route path="agreement_list" element={<AgreementListPage />} />
            <Route path="receipt" element={<ReceiptPage />} />
            <Route path="mobile_recharge" element={<MobileRecharge />} />
            <Route path="dth_recharge" element={<DTHRecharge />} />
            <Route path="distributor" element={<DistributorDashboard />} />
            <Route path="master_distributor" element={<SuperDistributorDashboard />} />
            <Route path="retailer" element={<RetailerDashboard />} />
            <Route path="pancard_user" element={<PancardUserDashboard />} />
            <Route path="cashout" element={<Cashout />} />
            <Route path="cashout_2" element={<Cashout2 />} />
            <Route path="admin_dashboard" element={<AdminDashboard />} />
            <Route path="api_partner" element={<ApiPartnerDashboard />} />
            <Route path="white_label" element={<WhiteLabelDashboard />} />
            <Route path="wallet_dmt" element={<PPIDMTScreen />} />
            <Route path="coming_soon" element={<ComingSoon />} />
            <Route path="bill_payment" element={<BillPayment />} />
            <Route path="bill_payment_new" element={<BillPaymentNEw />} />
             <Route path="offline_bill_payment" element={<OfflineBillPayment />} />
            <Route path="help" element={<MainFAQ />} />
            <Route path="wallet_settlement" element={<PSWalletSettlement />} />
            <Route path="rwallet_settlement" element={<MainRWalletSettlement />} />
            <Route path="callback" element={<AEPSCallback />} />
            <Route path="plan_info" element={<PlanInfo />} />
            <Route path="payment" element={<Payment />} />
            <Route path="payment_history" element={<PaymentHistory />} />
            <Route path="other_charge_list" element={<OtherChargeList />} />
            <Route path="other_payment_history" element={<OtherPaymentHistory />} />
            <Route path="paid_services" element={<PaidServicesManagement />} />
            <Route path="purchase_services" element={<PurchaseServices />} />
            <Route path="extra_services" element={<ExtraServicesManagement />} />
            <Route path="ott_subscription" element={<OttSubscription />} />
            <Route path="regbank" element={<RegBank />} />
            {/* <Route path="regbank" element={<RegBank />} /> */}
            <Route path="bank_accounts" element={<RegBank />} />
            <Route path="bank_whitelist" element={<RegBank />} />
'


            ////------ API Panel Route --------////


            <Route path="demo">
              <Route path="buttons" element={<Button />} />
            </Route>
          </Route>
          {apiPanelRouteElements}
          {/* ===== DEVELOPMENT ROUTES ===== */}
          {APP_CONFIG.IS_DEVELOPMENT && APP_CONFIG.ENABLE_DEV_TOOLS && (
            <Route path="/dev" element={<RouteWrapper><DeveloperDashboard /></RouteWrapper>} />
          )}

          {/* ===== ERROR ROUTES ===== */}
          <Route path="unauthorized" element={<UnauthorizedAccess />} />
          <Route path="not-found" element={<NotFound />} />
          <Route path="error_500" element={<Error500 />} />
          <Route path="error_503" element={<Error503 />} />
          <Route path="error_400" element={<Error400 />} />
          <Route path="error_403" element={<Error403 />} />
          <Route path="error_404" element={<Error404 />} />

          {/* ===== CATCH ALL ===== */}
          {/* <Route path="*" element={<Navigate to="/error_404" replace />} /> */}

        </Routes>
      </Suspense>

      {APP_CONFIG.IS_DEVELOPMENT && (
        <div className="position-fixed bottom-0 start-0 p-2">
          <span className="badge bg-warning text-dark">DEV MODE</span>
        </div>
      )}
    </>
  );
};

// ── Outer component — only provides context ──
const App = () => {
  return (
    <RefreshProvider>
      <AppContent />
    </RefreshProvider>
  );
};

export default App;

// // ===== PERFORMANCE MONITORING =====
// if (APP_CONFIG.PERFORMANCE_MONITORING) {
//   export default AppWithProfiler;
// } else {
//   export default AppWithErrorBoundary;
// }

// // ===== HOT MODULE REPLACEMENT (Development) =====
// if (APP_CONFIG.IS_DEVELOPMENT && module.hot) {
//   module.hot.accept("store/store", () => {
//     console.log("🔄 Hot reloading Redux store...");
//   });

//   module.hot.accept("Components", () => {
//     console.log
// ("🔄 Hot reloading components...");
//   });
// }
